(() => {
  'use strict';

  const header = document.querySelector('[data-tfu-site-header]');
  if (!header || header.dataset.ready === 'true') return;
  header.dataset.ready = 'true';

  const menu = header.querySelector('[data-tfu-mobile-menu]');
  const trigger = menu?.querySelector('summary');

  const syncMenuLabel = () => {
    trigger?.setAttribute('aria-label', menu?.open ? 'Close site menu' : 'Open site menu');
  };

  const closeMenu = ({ restoreFocus = false } = {}) => {
    if (!menu?.open) return;
    menu.open = false;
    if (restoreFocus) trigger?.focus();
  };

  menu?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => closeMenu());
  });
  menu?.addEventListener('toggle', syncMenuLabel);

  document.addEventListener('click', event => {
    if (menu?.open && !menu.contains(event.target)) closeMenu();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) {
      event.preventDefault();
      closeMenu({ restoreFocus: true });
    }
  });

  const syncScrolledState = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  syncMenuLabel();
  syncScrolledState();
  window.addEventListener('scroll', syncScrolledState, { passive: true });
})();
